import React from 'react';
import {Typography} from '../typography/Typography';
import {EyebrowProps} from '../eyebrow/Eyebrow';
import {Button, CmsButtonProps} from '../buttons/Button';
import Grid from '@material-ui/core/Grid';
import {GridContainer} from '../grid/GridContainer';
import {VerticalSpacer} from '../spacer';
import {AccentColorOptions, useBreakpointDown} from 'epic-ue-theme';
import {AnimateOnViewWrap} from '../../wraps';
import styled from 'styled-components';

export const CenteredTextBlockWrapper = styled.div<{accentColor: AccentColorOptions}>`
    text-align: center;
    h2 {
        color: ${(p) =>
            p.theme.ifLight(p, p.theme.palette.common.black, p.theme.palette.common.white)};
    }
    h4,
    .paragraph {
        color: ${(p) => p.theme.palette.text.secondary};
    }
    h4 {
        color: ${(p) => (p.accentColor ? p.theme.palette.accent[p.accentColor] : 'inherit')};
    }
`;

export interface CenteredTextBlockProps {
    eyebrow?: EyebrowProps;
    headline?: string;
    description?: string;
    button?: CmsButtonProps;
    button2?: CmsButtonProps;
    className?: string;
    accentColor?: AccentColorOptions;
}

export const CenteredTextBlock = (props: CenteredTextBlockProps): JSX.Element => {
    const {
        eyebrow,
        headline,
        description,
        button = {} as CmsButtonProps,
        button2 = {} as CmsButtonProps,
        className,
        accentColor = 'sky'
    } = props;

    const isSm = useBreakpointDown('sm');

    const {href, label, type} = button;
    const {href: href2, label: label2, type: type2} = button2;

    return (
        <CenteredTextBlockWrapper
            className={`centered-text-block ${className || ''}`}
            accentColor={accentColor}>
            <AnimateOnViewWrap translateY={30} key={headline}>
                <GridContainer>
                    <Grid container justifyContent="center" alignItems="center" direction="row">
                        <Grid item xs={12} md={8}>
                            {eyebrow && eyebrow.text && (
                                <>
                                    <Typography variant="h4" big>
                                        {eyebrow.text}
                                    </Typography>
                                    <VerticalSpacer variant="heading" />
                                </>
                            )}
                            {headline && (
                                <>
                                    <Typography variant="h2" big>
                                        {headline}
                                    </Typography>
                                </>
                            )}
                        </Grid>
                        {(description || href) && (
                            <Grid item xs={12} md={6}>
                                <VerticalSpacer variant="eyebrow" />
                                {description && <Typography variant="p">{description}</Typography>}
                                {(href || href2) && (
                                    <>
                                        <VerticalSpacer variant="heading" />
                                        {href && href2 ? (
                                            <Grid
                                                container
                                                justifyContent="center"
                                                alignItems="center"
                                                direction="row" 
                                                spacing={3} >
                                                <Grid item xs={12} md={6} style={{ display: isSm ? 'initial' : 'flex', justifyContent: isSm ? "center" : "flex-end"  }}>
                                                    <Button
                                                        type={type}
                                                        color={accentColor}
                                                        href={href}>
                                                        {label}
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={12} md={6} style={{ display: isSm ? 'initial' : 'flex', justifyContent:  isSm ? "center" : "flex-start" }}>
                                                    {isSm && (<VerticalSpacer variant="eyebrow" />)}
                                                    <Button
                                                        type={type2}
                                                        color={accentColor}
                                                        href={href2}>
                                                        {label2}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        ) : (
                                            <Button
                                                type={type || type2}
                                                color={accentColor}
                                                href={href || href2}>
                                                {label || label2}
                                            </Button>
                                        )}
                                    </>
                                )}
                            </Grid>
                        )}
                    </Grid>
                </GridContainer>
            </AnimateOnViewWrap>
        </CenteredTextBlockWrapper>
    );
};
